<template>
    <div class="calendar-wrapper">
      <!-- Header -->
      <div class="calendar-header">
        <div class="left-controls">
          <button @click="prevMonth">‹</button>
          <span class="month-title">{{ monthYear }}</span>
          <button @click="nextMonth">›</button>
          <button class="today-btn" @click="goToday">Today</button>
        </div>
      </div>
  
      <!-- Calendar -->
      <div class="calendar-grid">
        <div class="day header" v-for="d in weekDays" :key="d">{{ d }}</div>
  
        <div
          v-for="(day, i) in daysInMonth"
          :key="i"
          class="day"
          :class="{ today: isToday(day.date), selected: selectedDate === day.date }"
          @click="selectDate(day.date)"
        >
          <span v-if="day.day">{{ day.day }}</span>
        </div>
      </div>
  
      <!-- Schedule -->
      <div class="schedule-container" v-if="selectedDate">
        <div class="schedule-header">
          <h3>Schedule</h3>
          <span class="date-label">{{ formatDisplayDate(selectedDate) }}</span>
        </div>
  
        <div v-if="selectedClasses.length" class="schedule-list">
          <div v-for="(cls, idx) in selectedClasses" :key="idx" class="schedule-card">
            <div class="time-label">{{ cls.startTime }}</div>
  
            <div class="class-info">
              <div class="class-status" v-if="cls.status">
                <span class="status-dot"></span> {{ cls.status }}
              </div>
              <div class="class-title">{{ cls.code }} - {{ cls.name }}</div>
              <div class="class-teacher">with {{ cls.teacher }}</div>
              <div class="class-time">Time: {{ cls.startTime }} - {{ cls.endTime }}</div>
            </div>
  
            <div class="action-buttons">
              <button class="start-btn">Start Class</button>
              <button class="upload-btn">Upload Notes</button>
            </div>
          </div>
        </div>
  
        <div v-else class="no-class">
          <p>No class scheduled for this date.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "CalendarSchedule",
    data() {
      return {
        currentDate: new Date(),
        selectedDate: null,
        weekDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        classes: {
          "2025-09-16": [
            {
              code: "S062-FH007-T6",
              name: "SAINS",
              teacher: "Teacher Mira",
              startTime: "08:00 AM",
              endTime: "09:30 AM",
              status: "After 30 Mins",
            },
            {
              code: "S062-FH007-T6",
              name: "SAINS",
              teacher: "Teacher Mira",
              startTime: "02:00 PM",
              endTime: "02:30 PM",
            },
            {
              code: "S062-FH007-T6",
              name: "SAINS",
              teacher: "Teacher Mira",
              startTime: "03:00 PM",
              endTime: "03:30 PM",
            },
          ],
        },
      };
    },
    computed: {
      monthYear() {
        return this.currentDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        });
      },
      daysInMonth() {
        const year = this.currentDate.getFullYear();
        const month = this.currentDate.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
  
        const days = [];
        const startDay = firstDay.getDay();
  
        for (let i = 0; i < startDay; i++) {
          days.push({ day: "", date: null });
        }
  
        for (let d = 1; d <= lastDay.getDate(); d++) {
          const dateStr = `${year}-${(month + 1)
            .toString()
            .padStart(2, "0")}-${d.toString().padStart(2, "0")}`;
          days.push({ day: d, date: dateStr });
        }
        return days;
      },
      selectedClasses() {
        return this.classes[this.selectedDate] || [];
      },
    },
    methods: {
      isToday(dateStr) {
        const today = new Date();
        const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
        return dateStr === todayStr;
      },
      selectDate(dateStr) {
        if (dateStr) this.selectedDate = dateStr;
      },
      prevMonth() {
        this.currentDate = new Date(
          this.currentDate.getFullYear(),
          this.currentDate.getMonth() - 1,
          1
        );
      },
      nextMonth() {
        this.currentDate = new Date(
          this.currentDate.getFullYear(),
          this.currentDate.getMonth() + 1,
          1
        );
      },
      goToday() {
        this.currentDate = new Date();
        this.selectedDate = this.currentDate
          .toISOString()
          .split("T")[0];
      },
      formatDisplayDate(dateStr) {
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-MY", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .calendar-wrapper {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    max-width: 900px;
    margin: auto;
  }
  
  /* Header */
  .calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  .left-controls {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .left-controls button {
    background: #f3f4f6;
    border: none;
    border-radius: 6px;
    padding: 6px 10px;
    cursor: pointer;
    font-weight: 600;
  }
  .month-title {
    font-size: 18px;
    font-weight: 600;
  }
  .today-btn {
    background: #2563eb;
    color: white;
  }
  
  /* Calendar Grid */
  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-bottom: 20px;
  }
  .day {
    text-align: center;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
  }
  .day.header {
    font-weight: 600;
    color: #6b7280;
    background: #f9fafb;
  }
  .day:hover {
    background: #f3f4f6;
  }
  .today {
    background: #e0e7ff;
    border: 1px solid #2563eb;
  }
  .selected {
    background: #2563eb;
    color: white;
  }
  
  /* Schedule Section */
  .schedule-container {
    margin-top: 10px;
    background: #f9fafc;
    border-radius: 12px;
    padding: 15px;
  }
  .schedule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .schedule-header h3 {
    font-size: 18px;
    font-weight: 600;
  }
  .date-label {
    font-size: 14px;
    color: #6b7280;
  }
  .schedule-card {
    display: flex;
    align-items: flex-start;
    background: #fff;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    justify-content: space-between;
  }
  .time-label {
    width: 80px;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
  }
  .class-info {
    flex: 1;
  }
  .class-status {
    color: #dc2626;
    font-size: 12px;
    margin-bottom: 5px;
  }
  .status-dot {
    width: 8px;
    height: 8px;
    background: #dc2626;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
  }
  .class-title {
    font-weight: 600;
    color: #111827;
  }
  .class-teacher {
    color: #4b5563;
    font-size: 14px;
  }
  .class-time {
    color: #6b7280;
    font-size: 13px;
  }
  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .start-btn,
  .upload-btn {
    background: #2563eb;
    border: none;
    color: white;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 13px;
    cursor: pointer;
  }
  .upload-btn {
    background: white;
    color: #2563eb;
    border: 1px solid #2563eb;
  }
  .no-class {
    text-align: center;
    padding: 20px;
    color: #6b7280;
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .calendar-grid {
      gap: 2px;
    }
    .day {
      padding: 8px 0;
    }
    .schedule-card {
      flex-direction: column;
      align-items: flex-start;
    }
    .action-buttons {
      flex-direction: row;
      width: 100%;
      justify-content: flex-end;
    }
  }
  </style>